import Vue from 'vue'
import App from './layout/Template.vue'
import VueRouter from 'vue-router'
import routes from './routes.js'
import jQuery from 'jquery'
import VueFroala from 'vue-froala-wysiwyg'
import VuePlyr from 'vue-plyr';
import AsyncComputed from 'vue-async-computed'
import Meta from 'vue-meta'
import store from './store.js'
import Helpers from './helpers.js'
import "babel-polyfill";

import 'vue-plyr/dist/vue-plyr.css';
window.jQuery = jQuery;
window.$ = jQuery;

// Require Froala Editor
require('froala-editor/js/froala_editor.pkgd.min');
require('froala-editor/css/froala_editor.pkgd.min.css');
require('froala-editor/css/froala_style.min.css');

// Match height
require('jquery-equalheights/jquery.equalheights.min');

window.cms = "https://cms.why.si/";
window.seo = {
	"url": "http://why.si/",
	"name": "Why.si",
	"author": "",
	"description": "",
	"keywords": "",
	"image": ""
};

Vue.use(Helpers);
Vue.use(VuePlyr);
Vue.use(VueRouter);
Vue.use(VueFroala);
Vue.use(AsyncComputed);
Vue.use(Meta);

const router = new VueRouter({
	routes,
	mode: "history"
});

new Vue({
	el: '#app',
	router,
	store,
	render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js